module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - appear - 1chul_hyun.36dcfcfd.pdf";